import React from "react";
import { Link } from "react-router-dom";
import flex from "../assets/images/sidom/fotos/FlechaenCirc3.png";
import flex2 from "../assets/images/sidom/fotos/FlechaenCirc1.png";

export default function ButtonOrang({
  text,
  link = "#",
  background = "bg-sidom-orange",
  textColor = "text-white",
  borderColor = "border-transparent",
  showLineEffect = true,
  width,
  onClick,
  target, // <--- nueva prop
}) {
  // Si el link es externo (http) o target _blank, usar <a>
  const isExternal = target === "_blank" || /^https?:\/\//.test(link);
  return (
    <div className="relative">
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          className={`relative ${width} inline-flex h-12 transition active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none`}
        >
          {showLineEffect && (
            <div className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#ff7a00_0%,#fff_100%)]"></div>
          )}
          <div
            className={`relative inline-flex   h-full w-full items-center justify-center rounded-full px-5 text-nowrap text-base gap-3 ${borderColor} ${background} ${textColor}`}
          >
            <h1 className="font-extrabold tracking-wide ">{text}</h1>
            <img
              src={flex}
              alt="Logo-sidom "
              className="hidden dark:block w-5"
            />
            <img
              src={flex2}
              alt="Logo-sidom "
              className="block dark:hidden w-5"
            />
          </div>
        </button>
      ) : isExternal ? (
        <a
          href={link}
          target={target || (isExternal ? "_blank" : undefined)}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          className={`relative ${width}  inline-flex h-12 transition active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none`}
        >
          {showLineEffect && (
            <div className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#ff7a00_0%,#fff_100%)]"></div>
          )}
          <div
            className={`relative inline-flex  leading-snug h-full w-full items-center justify-center rounded-full px-5 text-nowrap text-base gap-3 ${borderColor} ${background} ${textColor}`}
          >
            <h1 className="font-extrabold tracking-wide ">{text}</h1>
            <img
              src={flex}
              alt="Logo-sidom "
              className="hidden dark:block w-5"
            />
            <img
              src={flex2}
              alt="Logo-sidom "
              className="block dark:hidden w-5"
            />
          </div>
        </a>
      ) : (
        <Link
          to={`${link}`}
          className={`relative ${width}  inline-flex h-12 transition active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none`}
        >
          {showLineEffect && (
            <div className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#ff7a00_0%,#fff_100%)]"></div>
          )}
          <div
            className={`relative inline-flex  leading-snug h-full w-full items-center justify-center rounded-full px-5 text-nowrap text-base gap-3 ${borderColor} ${background} ${textColor}`}
          >
            <h1 className="font-extrabold tracking-wide ">{text}</h1>
            <img
              src={flex}
              alt="Logo-sidom "
              className="hidden dark:block w-5"
            />
            <img
              src={flex2}
              alt="Logo-sidom "
              className="block dark:hidden w-5"
            />
          </div>
        </Link>
      )}
    </div>
  );
}
